"use strict";

(function () {

var self = Fotobook.substrate.booklet = {
    "BUTTONS" : {
        "x": 30,
        "y": 173,
    },

    recalculate: function () {
        $(document).triggerHandler(Fotobook.events.RECALC_SUBSTRATE);
    },

    // следует вынести сюда логику, связанную с зумом, но пока она размазана по коду
    // сей пустой метод был добавлен для совместимости с substrate.custom.js
    recalculateWithZoom() {},

    resize: function($book){
        var $pages = $book.find(".pages-wrapper").eq(0).find(".book-page"),
            page_type = $pages.attr("data-page_type"),
            displayRegion = page_type ? Fotobook.displayRegions.getRegion(page_type) : undefined;

        if (!$book.length || !displayRegion || !displayRegion.width) {
            return;
        }
        var
            $wrap = $book.closest(".main-wrapper"),
            pageMargins = Fotobook.substrate.getPageMargins(),
            h = $wrap.height() - 2 * Fotobook.mainPadding.y,
            w = $wrap.width() - 2 * (Fotobook.mainPadding.x + this.BUTTONS.x), // ширина рабочей области редактора
            spine_w = Fotobook.book.getSpineThickness(page_type), // ширина корешка
            // pageStack - блок краёв страниц выступающие слева и справа

            pages_count = $pages.length,
            fullPageSize = Fotobook.book.getFullPageSize(page_type),
            w_coeff = w / (pages_count * fullPageSize.width + pageMargins.width + spine_w),
            y_coeff = h / (fullPageSize.height + pageMargins.height),
            coeff = Math.min(w_coeff, y_coeff),
            fontSize = Math.round10(Fotobook.book.BASE_SIZE * coeff, -2);

        if ($('.single-preview-wrapper').length) {
            fontSize = fontSize * 0.9; // todo что за число 0.9???
        }

        $book.css("font-size", `${fontSize}px`).attr('data-fontSize', fontSize);
        if ($(document.documentElement).hasClass("preview")) { // todo реализовать апи проверки на preview
            var booklet = $(".preview-wrap").data("booklet");
            w = Math.round((w / w_coeff - pageMargins.width) * coeff);
            h = Math.round((h / y_coeff - pageMargins.height) * coeff);

            if (booklet && (booklet.option("width") !== w || booklet.option("height") !== h)) {
                booklet.option({"width": w, "height": h});
            }
        }
    },
};
})();
